import { Messages } from '@marriott/mi-ui-library';
import clsx from 'clsx';
import { LegalTextWithLink } from '../LegalTextWithLink';
import { StyledTermModalBody } from './TermModalBody.styles';
import { TermModalBodyProps } from './TermModalBody.type';

export function TermModalBody({ isError, isLoading, data, error }: TermModalBodyProps) {
  if (isLoading) return <div data-testid="skeleton-loader" className="skeleton-loader" />;
  if (isError) return <Messages messageType="error-sev1" className={clsx('p-5')} messageText={error} />;
  return (
    <StyledTermModalBody>
      <LegalTextWithLink descriptionText={data.content} />
    </StyledTermModalBody>
  );
}
